import getWindow from "./window";

export const handleModalTriggerEvent = ({
  focusOnCloseElement,
  position = null,
  eventKey,
}) => {
  getWindow().asos.eventBus.emit(eventKey, {
    focusOnCloseElement,
    position,
  });
};
